import { render, staticRenderFns } from "./PromotionXq.vue?vue&type=template&id=73b3d741&scoped=true&"
import script from "./PromotionXq.vue?vue&type=script&lang=js&"
export * from "./PromotionXq.vue?vue&type=script&lang=js&"
import style0 from "./PromotionXq.vue?vue&type=style&index=0&id=73b3d741&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b3d741",
  null
  
)

export default component.exports